<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">复购统计<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="选择门店" class="select-item" multiple collapse-tags collapse-tags-tooltip :max-collapse-tags="3" :disabled="checkAll">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <el-checkbox v-model="checkAll" style="margin-left: 8px;" @change="checkAllShop">全选</el-checkbox>
            </div>
            <div class="content-input-item">
              <DatePickerRange title="时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>


          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)">查询</ElButtons>
            </div>
<!--            <div class="content-input-btn">-->
<!--              <ElButtons icon="RefreshLeft" @click="refreshParam">重置</ElButtons>-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <div class="content-main">
        <div class="content-button">
          <div>
            <el-button type="warning" @click="exportExcel">导出Excel</el-button>
          </div>
          <div style="display: flex; align-items: center;">
            <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
          </div>

        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              @cell-click="toggleSelection"
              size="default"
              border
              @sort-change="sortChange"
          >
<!--            <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
            <el-table-column property="shopName" label="所属门店" v-if="checkColList.indexOf('所属门店') > -1"></el-table-column>
            <el-table-column property="totalUserNum" label="客户数" v-if="checkColList.indexOf('客户数') > -1" sortable='custom' width="100"/>
            <el-table-column property="shopNewUserNum" label="门店新客数" v-if="checkColList.indexOf('门店新客数') > -1" sortable='custom' width="160">
              <template #header>
                <span>
                  <span>门店新客数</span>
                   <el-tooltip
                       class="box-item"
                       effect="dark"
                       content=""
                       placement="top"
                   >
                     <template #content>门店新客数=全新客户+首次到本店消费的客户（此前在别的门店消费过）</template>
                    <ElIcons name="QuestionFilled" :size="18" class="icon-btn"/>
                  </el-tooltip>
                </span>
              </template>
              <template #default="scope">
                <div style="display: flex; justify-content: space-between">
                  <p>{{scope.row.shopNewUserNum}}</p>
                  <p style="color: #aaaaaa">{{scope.row.newUserNum}}+{{scope.row.otherNewUserNum}}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="shopOldUserNum" label="门店老客数" v-if="checkColList.indexOf('门店老客数') > -1" sortable='custom' width="140"/>
            <el-table-column property="" label="复购1次" v-if="checkColList.indexOf('复购1次') > -1" align="center">
              <el-table-column property="oneNum" label="人数" sortable='custom'/>
              <el-table-column property="oneNumPct" label="比例" sortable='custom'>
                <template #default="scope">
                  {{scope.row.oneNumPct}}%
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column property="" label="复购2次" v-if="checkColList.indexOf('复购2次') > -1" align="center">
              <el-table-column property="twoNum" label="人数" sortable='custom'/>
              <el-table-column property="twoNumPct" label="比例" sortable='custom'>
                <template #default="scope">
                  {{scope.row.twoNumPct}}%
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column property="" label="复购1次及以上" v-if="checkColList.indexOf('复购1次及以上') > -1" align="center">
              <el-table-column property="shopOldUserNum" label="人数" sortable='custom'/>
              <el-table-column property="shopOldUserNumPct" label="比例" sortable='custom'>
                <template #default="scope">
                  {{scope.row.shopOldUserNumPct}}%
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column property="" label="复购2次及以上" v-if="checkColList.indexOf('复购2次及以上') > -1" align="center" >
              <el-table-column property="twoMoreNum" label="人数" sortable='custom'/>
              <el-table-column property="twoMoreNumPct" label="比例" sortable='custom'>
                <template #default="scope">
                  {{scope.row.twoMoreNumPct}}%
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column property="" label="复购3次及以上" v-if="checkColList.indexOf('复购3次及以上') > -1" align="center">
              <el-table-column property="threeMoreNum" label="人数" sortable='custom'/>
              <el-table-column property="threeMoreNumPct" label="比例" sortable='custom'>
                <template #default="scope">
                  {{scope.row.threeMoreNumPct}}%
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {getFormData, imgPostFormData, postFormData} from "@/api/api";
import {getStatShopRepurchaseList, exportShopRepurchaseExcel, getConsumeStatSummary} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import UserInfo from "@/components/User/userInfo";
import DatePickerRange from "@/components/DatePickerRange_365_1";
import RecordList from "@/views/user/components/RecordList";
import SearchUidOrPhone from "@/components/SearchUidOrPhone";
import SearchInfoDialog from "@/views/user/components/SearchInfoDialog";
import { decimal_NUM, add } from "@/assets/shared/util";
import unLock from "@/layout/components/unLock";

export default {
  name: "StatRepurchase",
  components: {BtnGroup, SearchComponents, SearchUidOrPhone, UserInfo, DatePickerRange, RecordList, unLock },
  data() {
    return {
      pageDataList: [],
      sumDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      shopIdArray: [],
      shopIdArr:[],
      shopId: [],
      checkAll: true,

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
        {label: '未知', value: 0}
      ],
      sex: -1,


      //刷新组
      colList: ['所属门店', '客户数', '门店新客数', '门店老客数', '复购1次', '复购2次', '复购1次及以上', '复购2次及以上', '复购3次及以上'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '称呼', value : 2},
      ],
      searchType: 1,
      searchValue: '',

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //抵扣时间
      startDeductionTime: '',
      endDeductionTime: '',
      isDeductionChecked: true,

      idArray: [],
      sort: 1,

      upChargeLoading: false,


    }
  },
  methods: {

    // shopChange(e) {
    //   // console.log(e)
    //   // console.log(this.shopId)
    //   if(e.length == 0) {
    //     this.shopId = [-1]
    //   }
    //   if(this.shopId[0] == -1) {
    //     this.shopId.splice(0, 1)
    //   }else if(this.shopId.indexOf(-1) > -1) {
    //     this.shopId = [-1]
    //   }
    // },

    checkAllShop(val) {
      console.log(val)
      if(val) {
        this.shopId = []
      }
    },

    //排序
    sortChange(column) {
      if(column.prop == 'totalUserNum') {
        if(column.order == 'descending') {
          this.sort = 1;
        } else if(column.order == 'ascending') {
          this.sort = 2;
        }
      } else if(column.prop == 'shopNewUserNum') {
        if(column.order == 'descending') {
          this.sort = 3;
        } else if(column.order == 'ascending') {
          this.sort = 4;
        }
      }else if(column.prop == 'shopOldUserNum') {
        if(column.order == 'descending') {
          this.sort = 5;
        } else if(column.order == 'ascending') {
          this.sort = 6;
        }
      }else if(column.prop == 'shopOldUserNumPct') {
        if(column.order == 'descending') {
          this.sort = 7;
        } else if(column.order == 'ascending') {
          this.sort = 8;
        }
      }else if(column.prop == 'oneNum') {
        if(column.order == 'descending') {
          this.sort = 9;
        } else if(column.order == 'ascending') {
          this.sort = 10;
        }
      }else if(column.prop == 'oneNumPct') {
        if(column.order == 'descending') {
          this.sort = 11;
        } else if(column.order == 'ascending') {
          this.sort = 12;
        }
      }else if(column.prop == 'twoNum') {
        if(column.order == 'descending') {
          this.sort = 13;
        } else if(column.order == 'ascending') {
          this.sort = 14;
        }
      }else if(column.prop == 'twoNumPct') {
        if(column.order == 'descending') {
          this.sort = 15;
        } else if(column.order == 'ascending') {
          this.sort = 16;
        }
      }else if(column.prop == 'twoMoreNum') {
        if(column.order == 'descending') {
          this.sort = 17;
        } else if(column.order == 'ascending') {
          this.sort = 18;
        }
      }else if(column.prop == 'twoMoreNumPct') {
        if(column.order == 'descending') {
          this.sort = 19;
        } else if(column.order == 'ascending') {
          this.sort = 20;
        }
      }else if(column.prop == 'threeMoreNum') {
        if(column.order == 'descending') {
          this.sort = 21;
        } else if(column.order == 'ascending') {
          this.sort = 22;
        }
      }else if(column.prop == 'threeMoreNumPct') {
        if(column.order == 'descending') {
          this.sort = 23;
        } else if(column.order == 'ascending') {
          this.sort = 24;
        }
      }

      this.getPage();
    },

    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.isDeductionChecked = true;
      this.sex = -1;
      this.shopId = 0;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    // //获取选中id
    // selsChange(sels) {
    //   this.idArray = sels.map(item => item.userId);
    // },
    //
    // //全选
    // selsAll(column, event) {
    //   if(column.type == 'selection') {
    //     let array = this.idArray;
    //     if(array.length == this.pageDataList.length) {
    //       array = [];
    //     }
    //     this.pageDataList.forEach(item => {
    //       if(array.indexOf(item.userId) === -1) {
    //         this.$refs.multipleTableRef.toggleRowSelection(item);
    //       }
    //     })
    //   }
    // },


    getPage(reset) {
      if(!this.checkAll && this.shopId.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请先选择门店',
          type: 'warning'
        })
        return false
      }
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      // param['pageNum'] = page;
      let ids = []
      if(this.checkAll) {
        this.shopIdArray.map(item => {
          ids.push(item.id)
        })
      }else {
        ids = this.shopId
      }
      param['shopIds'] = ids.toString();
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['sort'] = this.sort;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getStatShopRepurchaseList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result;
          // this.totalRow = result['total'];
          // this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },


    exportExcel() {
      let ids = []
      if(this.checkAll) {
        this.shopIdArray.map(item => {
          ids.push(item.id)
        })
      }else {
        ids = this.shopId
      }
      let url = HOST + exportShopRepurchaseExcel + '?shopIds=' + ids.toString() + '&startTime=' + (this.startTime?this.startTime:'') + '&endTime=' + (this.endTime?this.endTime:'') + '&sort=' + this.sort;
      window.location.href = url;
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },


    toggleSelection(row, column, cell, event) {

      // if(column.type == 'selection') {
      //   this.$refs.multipleTableRef.toggleRowSelection(row)
      // }

    },


    //搜索
    openDialog(e) {
      // console.log(e)
      Dialog.open({
        title: '',
        component: SearchInfoDialog,
        data: {
          userForm: e,
          width: '700px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    let visibleShopList = JSON.parse(sessionStorage.getItem('visibleShopList'))
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList')).filter(s => s.openState == 1)
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
    if(JSON.parse(sessionStorage.getItem('isSuper')) == 1){
      this.shopIdArray.push({name:'整体', id:0})
    }
    this.getPage();

  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
</style>
